<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getAddressOptions,
} from '@qx/utils';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        orderStateOptions: [], // 状态
        form: [
          { // 订单号码
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          { // 发车时间
            label: '发车时间',
            value: 'DependTime',
            type: 'date',
            placeholder: '请选择发车时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 客户名称
            label: '客户名称',
            value: 'customName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          { // 车牌号
            label: '车牌号',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号',
          },
          {
            label: '起点位置',
            value: 'sourceRegion',
            type: 'cascader',
            clearable: true,
            default: [],
            options: getAddressOptions(),
          },
          {
            label: '终点位置',
            value: 'desRegion',
            type: 'cascader',
            clearable: true,
            default: [],
            options: getAddressOptions(),
          },
          { // 状态
            label: '状态',
            value: 'orderState',
            type: 'select',
            default: '-1',
            placeholder: '请选择状态',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 发车时间
      if (searchBoxData.DependTime && searchBoxData.DependTime.length > 0) {
        searchBoxData.beginDependTime = this.formatDate(searchBoxData.DependTime[0]);
        searchBoxData.endDependTime = this.formatDate(searchBoxData.DependTime[1]);
        delete searchBoxData.DependTime;
      }
      searchBoxData.sourceRegion = searchBoxData.sourceRegion[1];
      searchBoxData.desRegion = searchBoxData.desRegion[1];
      searchBoxData.orderId = this.$route.query.orderId;

      this.$refs.tableBox.saveSearchBoxData({
        salaryId: this.$route.query.id,
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'ORDER_STATE',
    });
    this.searchBoxData.orderStateOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
